export default __webpack_public_path__ + "static/media/whatsapp.5aa4ab9b.svg";